import { ContentBlockType } from "@/models";
import { cardThemeToTailwindClasses } from "./converters-by-type/cardConverter";
import { sectionThemeToTailwindClasses } from "./converters-by-type/sectionConverter";
import { accordionThemeToTailwindClasses } from "./converters-by-type/accordionConverter";
import { navbarThemeToTailwindClasses } from "./converters-by-type/navbarConverter";
import { buttonThemeToTailwindClasses } from "./converters-by-type/buttonConverter";
import { topDrawerThemeToTailwindClasses } from "./converters-by-type/topDrawerConverter";
import { pageThemeToTailwindClasses } from "./converters-by-type/pageConverter";
import { cardDeckThemeToTailwindClasses } from "./converters-by-type/cardDeckConverter";
import { boxThemeToTailwindClasses } from "./converters-by-type/boxConverter";
import { tableThemeToTailwindClasses } from "./converters-by-type/tableConverter";

const coversionMap: Partial<
    Record<ContentBlockType, (theme: any) => string[]>
> = {
    [ContentBlockType.Accordion]: accordionThemeToTailwindClasses,
    [ContentBlockType.Box]: boxThemeToTailwindClasses,
    [ContentBlockType.Button]: buttonThemeToTailwindClasses,
    [ContentBlockType.Card]: cardThemeToTailwindClasses,
    [ContentBlockType["Card Deck"]]: cardDeckThemeToTailwindClasses,
    [ContentBlockType.Navbar]: navbarThemeToTailwindClasses,
    [ContentBlockType.Page]: pageThemeToTailwindClasses,
    [ContentBlockType.Section]: sectionThemeToTailwindClasses,
    [ContentBlockType.Table]: tableThemeToTailwindClasses,
    [ContentBlockType["Top Drawer"]]: topDrawerThemeToTailwindClasses,
};

export const contentBlockTypeToTailwindClasses = (
    contentBlockType: ContentBlockType,
    theme: any,
) => {
    return coversionMap[contentBlockType]?.(theme) || [];
};
